import { css } from 'styled-components';

const getColumnsFromSpan = (spanCalcs)=>{
    let colCalcs = [];
    for (const spanCalc of spanCalcs){
        if (!isNaN(Number(spanCalc)) && spanCalc !== "content") {
            // use the span to calculate number of fractions needed for columns
            colCalcs.push(spanCalc + "fr");
        } else if (spanCalc === "content") {
            colCalcs.push("min-content");
        }
    }
    return colCalcs;
};
/**
 * Generate standard grid + ie11 compatible grid stylings.
 * For use within Styled Components as a CSS helper.
 *
 * If this needs to be modified in any way, please check ie11 compatibility of grid
 * properties (as it varies). Example ie11 grid transformations can be found here;
 * https://css-tricks.com/css-grid-in-ie-debunking-common-ie-grid-misconceptions/
 * and styles can be manually generated here;
 * https://autoprefixer.github.io/
 *
 * @example
 * // grid-template-columns: 1fr 1fr 1fr;
 * ie11GridGenerateTemplateColumns([1,1,1])
 *
 * // grid-template-columns: 1fr 2fr 3fr;
 * ie11GridGenerateTemplateColumns([1,2,3], 'fill')
 *
 * // grid-template-columns: min-content min-content;
 * ie11GridGenerateTemplateColumns([1,1,1], 'content')
 */ const CSSGridGenerateCompatibleTemplateColumns = (cols, gap = 0)=>(spanCalcs)=>{
        const gapSpacer = gap > 0 ? ` ${gap}rem ` : " ";
        const GridColumnsCSS = css`
      -ms-grid-columns: ${getColumnsFromSpan(spanCalcs).join(gapSpacer)};
      -ms-grid-rows: 1fr;
      grid-gap: ${gap};
      grid-template-columns: ${getColumnsFromSpan(spanCalcs).join(" ")};
    `;
        const IE11GridColumnSet = spanCalcs.map((col, index)=>{
            const columnOffset = gap > 0 ? index : 0;
            return css`
        & > [data-hpy-web-column]:nth-child(${index + 1}) {
          -ms-grid-column: ${index + 1 + columnOffset};
        }
      `;
        });
        return css`
      ${GridColumnsCSS}
      ${!cols ? IE11GridColumnSet : ""}
    `;
    };
/**
 * Generate standard grid column + ie11 compatible grid stylings
 * For use within Styled Components as a CSS helper.
 *
 * Supports start & span of grid columns.
 *
 * If this needs to be modified in any way, please check ie11 compatibility of grid
 * properties (as it varies). Example ie11 grid transformations can be found here;
 * https://css-tricks.com/css-grid-in-ie-debunking-common-ie-grid-misconceptions/
 * and styles can be manually generated here;
 * https://autoprefixer.github.io/
 *
 * @example
 * // grid-column: 2
 * IE11GridGenerateColumnCSS(2)
 * // grid-column: 2 / span 3
 * IE11GridGenerateColumnCSS(2, 3)
 */ const CSSGridGenerateCompatibleColumn = ({ startCol , spanCols  })=>{
    if (!startCol && startCol !== 0) {
        return "";
    }
    if (!spanCols) {
        return css`
      display: none;
    `;
    }
    return css`
    display: flex;
    /* -ms-grid-row* properties added to ensure Column takes full height of Columns */
    -ms-grid-row: 1fr;
    -ms-grid-row-span: 1;
    grid-column: ${spanCols ? startCol + " / span " + spanCols : startCol};
    -ms-grid-column: ${startCol};
    -ms-grid-column-span: ${spanCols};
    [data-hpy-web-columns-with-gap] & {
      -ms-grid-column: ${startCol * 2 - 1};
      -ms-grid-column-span: ${spanCols * 2 - 1};
    }
  `;
};

export { CSSGridGenerateCompatibleColumn, CSSGridGenerateCompatibleTemplateColumns };
